module.exports = __webpack_public_path__ + "assets/11576ac5ec219f670882dd8a0f61d823.jpg";